import { theme as antdTheme, type ThemeConfig } from 'antd';

// KTP kurumsal kimlik renkleri.
export const KTP = {
  red: '#BA2038',
  federalBlue: '#080A4F',
  delftBlue: '#243568',
  blueGreen: '#3B9EC5',
  yellow: '#EFCB56',
  black: '#01010F',
  white: '#F5F4F2',
  deepGraphite: '#0F0D0E',
  darkGraphite: '#221E20',
  smokeGraphite: '#3D3839',
  smokyGray: '#584D4D',
  stoneGray: '#95999A',
  lightStone: '#CED1D1',
  frameOrange: '#E24733',
  frameBlue: '#CED1D1',
  frameMidnight: '#0F0D0E',
  deepRed: '#B42A1E',
  coralRed: '#EB7760',
  bordeauxGraphite: '#492220',
};

// Birincil marka rengi (delft blue) — genel buton/link vurguları.
export const brandColor = KTP.delftBlue;

const FONT_FAMILY =
  "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";

// Sayfa arka planı (açık/koyu) — koyu grafit taban +
// neon/mercan kırmızı ve taş grisi dengesi.
export const LIGHT_BG =
  'radial-gradient(720px 720px at 12% 6%, rgba(226,71,51,0.08), transparent 62%),' +
  'radial-gradient(860px 860px at 90% 0%, rgba(73,34,32,0.08), transparent 64%),' +
  '#CED1D1';

export const DARK_BG =
  'radial-gradient(105% 78% at 16% 8%, rgba(226,71,51,0.16), transparent 54%),' +
  'radial-gradient(95% 76% at 92% 0%, rgba(73,34,32,0.34), transparent 58%),' +
  'linear-gradient(180deg, #221E20 0%, #0F0D0E 58%, #0F0D0E 100%)';

export const FRAME_BG =
  'radial-gradient(115% 92% at 14% 8%, rgba(226,71,51,0.2), transparent 44%),' +
  'radial-gradient(92% 82% at 88% 2%, rgba(73,34,32,0.42), transparent 56%),' +
  'radial-gradient(70% 68% at 50% 74%, rgba(88,77,77,0.16), transparent 58%),' +
  'linear-gradient(180deg, #221E20 0%, #0F0D0E 48%, #0F0D0E 100%)';

const baseToken = {
  colorPrimary: brandColor,
  colorInfo: brandColor,
  borderRadius: 10,
  fontFamily: FONT_FAMILY,
};

const lightTheme: ThemeConfig = {
  token: { ...baseToken },
  components: {
    Button: { controlHeightLG: 46, fontWeight: 600 },
  },
};

const darkTheme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    ...baseToken,
    colorBgLayout: '#070a12',
    colorBgContainer: '#0e1626',
    colorBgElevated: '#111c30',
    colorBorder: 'rgba(255,255,255,0.10)',
    colorBorderSecondary: 'rgba(255,255,255,0.06)',
    colorText: '#e2e8f0',
    colorTextSecondary: '#94a3b8',
  },
  components: {
    Button: { controlHeightLG: 46, fontWeight: 600 },
  },
};

export const getTheme = (mode: 'light' | 'dark'): ThemeConfig =>
  mode === 'dark' ? darkTheme : lightTheme;

export default lightTheme;
